import React from 'react'
// import GameIconButton from '../GameIconButton/GameIconButton'
import { GameIconButton } from '@themed-components';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'

export default function GameScrollButton() {

    const handleScrollDown = () => {
        // Find the game container with snap scroll
        const gameContainer = document.querySelector('[class*="gameContainer"]');

        if (gameContainer) {
            // Scroll to the bottom (GameSwipeSettings) with smooth behavior
            gameContainer.scrollTo({
                top: gameContainer.scrollHeight,
                behavior: 'smooth'
            });
        }
    }

    return (
        <GameIconButton onClick={() => handleScrollDown()}>
            {/* Scroll Down Button */}
            <MdOutlineKeyboardArrowDown />
        </GameIconButton>
    )
}
